import { useTranslation } from 'next-i18next';

export const useCancelLimitOrderToastOpts = () => {
  const { t } = useTranslation();

  return {
    onMutateToastOpts: {},
    onSuccessToastOpts: {
      description: t('common.Limit Order Canceled'), // TODO: confirm cp
    },
    onErrorToastOpts: {},
  };
};
